import storage from '~gatsby-theme-autonomy/services/storage'

export const persist = (store) => (next) => (action) => {
  const previousState = store.getState()
  const result = next(action)
  const nextState = store.getState()
  const initalizeUser =
    !!process.env.GATSBY_OPTIONS_LOAD_USER_DURING_INITIALIZATION

  if (previousState.cart.data.number !== nextState.cart.data.number) {
    storage.setItem('cart-number', nextState.cart.data.number)
  }

  if (previousState.cart.data.token !== nextState.cart.data.token) {
    storage.setItem('cart-token', nextState.cart.data.token)
  }

  if (previousState.auth.isLoggedIn !== nextState.auth.isLoggedIn) {
    storage.setItem('chord-auth-logged-in', nextState.auth.isLoggedIn)
  }

  if (initalizeUser) {
    if (previousState.auth.token !== nextState.auth.token) {
      storage.setItem('chord-auth-token', nextState.auth.token)
    }
  }

  return result
}
